import {
  BUDGET_TABLE_FILTERS,
  BudgetFiltersKey,
} from '../../../utils/constants/budget';
import useOptions from './useOptions';

const useBudgetFilters = () => {
  const {
    learningTeamOptions,
    projectOptions,
    programOptions,
    budgetSourceOptions,
    vendorOptions,
  } = useOptions();

  const getOptionsByKey = (key: BudgetFiltersKey) => {
    switch (key) {
      case BUDGET_TABLE_FILTERS.PROGRAMS:
        return programOptions;
      case BUDGET_TABLE_FILTERS.PROJECTS:
        return projectOptions;
      case BUDGET_TABLE_FILTERS.VENDORS:
        return vendorOptions;
      case BUDGET_TABLE_FILTERS.TEAMS:
        return learningTeamOptions;
      case BUDGET_TABLE_FILTERS.BUDGET_SOURCES:
        return budgetSourceOptions;
      case BUDGET_TABLE_FILTERS.ADDITIONAL_FLAGS:
        return [{ label: 'Cost Of Labor', value: 'costOfLabor' }];
      case BUDGET_TABLE_FILTERS.BUDGET_ID:
        return [];

      default:
        return [];
    }
  };

  return {
    programOptions,
    projectOptions,
    vendorOptions,
    learningTeamOptions,
    budgetSourceOptions,
    getOptionsByKey,
  };
};

export default useBudgetFilters;
